import { render, staticRenderFns } from "./Daystogo.vue?vue&type=template&id=87cc5270&"
import script from "./Daystogo.vue?vue&type=script&lang=js&"
export * from "./Daystogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports